import MainLayout from '@/common/components/layouts/MainLayout';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { bodyStepDriverData } from '@/modules/adjusterReportModules/Insurer-information/data/bodyStepsData';
import { BodyDriverInfoTypeForm } from '@/modules/adjusterReportModules/Insurer-information/pages/driver-owner/driverInfo/BodyDriverInfo.type';
import { getInsurerInformationDriverInfoQueryOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationDriverInfo/getInsurerInformationDriverInfoQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout
      title="بیمه گذار / راننده"
      header="closeHeader"
      hasBottomPadding
    >
      <BodyDriverInfo>{children}</BodyDriverInfo>
    </MainLayout>
  );
};

const BodyDriverInfo = ({ children }: PropsWithChildren) => {
  const { id } = useParams();
  const { data } = useQuery(
    getInsurerInformationDriverInfoQueryOptions({
      id: Number(id),
    }),
  );
  const methods = useForm<BodyDriverInfoTypeForm>({
    mode: 'onChange',
  });
  useEffect(() => {
    if (data) {
      methods.reset({
        id: data?.id,
        contact_information: data?.contact_information,
        personal_information: {
          ...data?.personal_information,

          at_fault_identifier: data?.personal_information?.at_fault_identifier
            ?.value
            ? {
                ...data?.personal_information?.at_fault_identifier,
                value: String(
                  data?.personal_information?.at_fault_identifier?.value,
                ),
              }
            : undefined,
          at_fault: data?.personal_information?.at_fault?.value
            ? {
                ...data?.personal_information?.at_fault,
                value: String(data?.personal_information?.at_fault.value),
              }
            : undefined,
        },
        certificate_information: {
          license_number: data?.certificate_information?.license_number,
          license_type: data?.certificate_information?.license_type?.value
            ? {
                ...data?.certificate_information?.license_type,
                value: data?.certificate_information?.license_type?.value,
              }
            : undefined,
          license_issue_date: data?.certificate_information?.license_issue_date,
          license_issue_location_country: data?.certificate_information
            ?.license_issue_location_country?.value
            ? {
                ...data?.certificate_information
                  ?.license_issue_location_country,
                value:
                  data?.certificate_information?.license_issue_location_country
                    ?.value,
              }
            : undefined,
          iran_license_issue_location_city:
            data?.certificate_information?.license_issue_location_country
              .value === 103
              ? {
                  label:
                    data?.certificate_information
                      ?.iran_license_issue_location_city?.label,
                  value:
                    data?.certificate_information
                      ?.iran_license_issue_location_city?.value,
                }
              : null,
          license_issue_location_city:
            data?.certificate_information?.license_issue_location_city,
          driver_license_is_extension:
            data?.certificate_information?.driver_license_is_extension,
        },
      });
      setTimeout(() => {
        methods.trigger('certificate_information.license_issue_date');
        methods.trigger('personal_information.birthdate');
      });
    }
  }, [data, methods]);

  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={bodyStepDriverData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <ImagesFabMainModal state="body" />

      <Box width="100%">
        <FormProvider {...methods}>{children}</FormProvider>
      </Box>
    </>
  );
};
